@if (busy) {
  <mat-spinner class="spinner-inline"></mat-spinner>
  @if (showLabel) {
    <span>{{ label }}</span>
  }
} @else {
  <ng-content></ng-content>
}
